import type { OptionState } from '@openx/types/options.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';
import { toList } from '../../targeting/utils/toList.ts';
import { toMapById } from '../../targeting/utils/toMapById.ts';

export const useOldDistributionChannelOptionsFetch = (): OptionState => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.package.targeting.inventory_format.distribution_channel',
    },
  });

  const list = useMemo(() => toList(optionsByPath), [optionsByPath]);
  const mapById = useMemo(() => toMapById(list), [list]);

  return {
    list,
    loading,
    mapById,
    refetch,
  };
};
